module.exports = __webpack_public_path__ + "images/main_woman.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/main_woman.png
// module id = 1126
// module chunks = 0